import { Component } from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import qs from 'qs'
import { List } from 'semantic-ui-react'

import { downloadFileFromResponse } from 'utils/requests'
import { sliceArray } from 'utils/transformations/array'
import { fromGlobalId, toGlobalId } from 'utils/transformations/graphql'

import Checkbox from 'components/Core/Checkbox/Checkbox'
import Dropdown from 'components/Core/Dropdown/Dropdown'
import Modal from 'components/Core/Modal'

import { ExportDataIds } from '../ExportData.ids'
import styles from '../ExportDataModal.component.module.css'
import messages from '../ExportDataModal.messages'

const MAX_ORDERS_PER_EXPORT = 50
const CUSTOM_ORDER = 'CUSTOM_ORDER'

export default class ExportRawDataModal extends Component {
  state = {
    options: {},
  }

  onSave = () => {
    const { options } = this.state

    const { handleExportAction, trackExportRawDataModalSubmitted } = this.props

    trackExportRawDataModalSubmitted({
      integrationsDropdownOptions: this.getIntegrationsDropdownOptions(),
      options,
    })

    handleExportAction(
      this.exportOrders,
      messages.downloadCompleted,
      messages.failedExport,
    )
  }

  setOrderExport = (e, { value }) => {
    const { options } = this.state
    const { id: orderExportIntegrationId } = fromGlobalId(value)

    this.setState({
      options: {
        ...options,
        account_integration_id: orderExportIntegrationId,
      },
    })
  }

  getIntegrationsDropdownOptions = () => [
    ...this.props.orderExportIntegrations
      .filter((option) => option.integrationType !== CUSTOM_ORDER)
      .map((option) => ({
        value: option.id,
        text: option.name,
        className: 'notranslate',
      })),
    {
      value: toGlobalId('OrderExportIntegration', '0'),
      text: messages.basicExport,
    },
  ]

  getRequestData = (selectedOrders) => {
    const { format, options } = this.state
    const ordersToExport = selectedOrders.reduce(
      (acc, globalId) => {
        const { id: orderId } = fromGlobalId(globalId)
        acc.data.Download[orderId] = 'on'
        return acc
      },
      { data: { Download: {} } },
    )

    const data = {
      ...options,
      ...ordersToExport,
      selected_tab: format,
      from_react: true,
    }

    return qs.stringify(data)
  }

  exportOrders = () => {
    const { selectedOrders } = this.props
    const selectedOrdersSlices = sliceArray(
      selectedOrders,
      MAX_ORDERS_PER_EXPORT,
    )

    const requests = selectedOrdersSlices.map((selectedOrdersSlice) => {
      const data = this.getRequestData(selectedOrdersSlice)
      // TODO(ch15457) rebuild endpoint
      return downloadFileFromResponse('/orders/download_orders/', data)
    })

    return Promise.all(requests)
  }

  toggleOption = (e, { value }) => {
    const { options } = this.state
    const optionIsEnabled = options[value] && options[value] === 'true'

    this.setState({
      options: {
        ...options,
        [value]: optionIsEnabled ? 'false' : 'true',
      },
    })
  }

  renderExportOption = (exportOption) => {
    const { value, label, disabled } = exportOption
    const { options } = this.state
    const isSelected = options[value] && options[value] === 'true'

    return (
      <List.Item key={value}>
        <Checkbox
          label={label}
          value={value}
          checked={isSelected}
          disabled={disabled}
          onClick={this.toggleOption}
        />
      </List.Item>
    )
  }

  render() {
    const { allowMarkOrderExported } = this.props
    return (
      <Modal
        open
        onClose={this.props.onClose}
        primaryActionOnClick={this.onSave}
        primaryActionLabel={messages.export}
        title={messages.exportData}
        primaryActionId={ExportDataIds.ExportDataButton}
      >
        <List>
          <List.Item>
            <span className={styles.label}>
              {messages.selectIntegrationType}
            </span>
            <Dropdown
              className={classNames(styles.dropdown, 'notranslate')}
              placeholder={messages.selectOne}
              options={this.getIntegrationsDropdownOptions()}
              onChange={this.setOrderExport}
              defaultValue={toGlobalId('OrderExportIntegration', '0')}
            />
          </List.Item>
          <span className={classNames(styles.label, styles.section)}>
            {messages.integrationOption}
          </span>
          {this.renderExportOption({
            label: messages.markExported,
            value: 'mark_exported',
            disabled: !allowMarkOrderExported,
          })}
        </List>
      </Modal>
    )
  }
}

ExportRawDataModal.propTypes = {
  onClose: PropTypes.func,
  selectedOrders: PropTypes.arrayOf(PropTypes.string),
  orderExportIntegrations: PropTypes.arrayOf(PropTypes.object),
  handleExportAction: PropTypes.func.isRequired,
  allowMarkOrderExported: PropTypes.bool,
  trackExportRawDataModalSubmitted: PropTypes.func,
}

ExportRawDataModal.defaultProps = {
  onClose: () => {},
  selectedOrders: [],
  allowMarkOrderExported: false,
  orderExportIntegrations: [],
  trackExportRawDataModalSubmitted: () => {},
}
